import { z } from "zod";

export const accountSchema = z
    .object({
        loginId: z
            .string()
            .min(4, "아이디는 4자 이상이어야 합니다")
            .max(16, "아이디는 16자 이하이어야 합니다")
            .nonempty("아이디를 입력해주세요"),
        password: z
            .string()
            .regex(
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/,
                "비밀번호는 영어, 숫자, 특수문자(@,$,!,%,*,#,?,&)를 포함한 8자 이상 16자 이하이어야 합니다"
            ),
        passwordConfirm: z.string(),
    })
    .refine((data) => data.password === data.passwordConfirm, {
        message: "비밀번호가 일치하지 않습니다",
        path: ["passwordConfirm"],
    });
